'use client'

import React, { FC } from 'react'
import { FeedbackModal } from './FeedbackModal'
import { useAppStore } from '@/store/useAppStore';

interface Props {
    handleRewardModalClose: () => void
}

export const ShowRewardModal: FC<Props> = ({handleRewardModalClose}) => {
      const { userScore } =
        useAppStore();
  return (
  <FeedbackModal
          type="success"
          handleContinue={handleRewardModalClose}
          showConfetti={true}
        >
          <div className="text-6xl mb-4">🎉</div>

          <h2 className="text-2xl font-bold text-white mb-4">
            Sharing Bonus Earned!
          </h2>

          <p className="text-gray-200 mb-6 leading-relaxed">
            Thanks for spreading the word about Probabl! You've earned a special sharing bonus.
          </p>

          <div className="bg-green-500/20 rounded-lg p-6 mb-6 border border-green-500/30">
            <div className="text-center">
              <div className="text-4xl font-bold text-green-400 mb-2">+500</div>
              <div className="text-green-300 text-lg">Bonus Points!</div>
              <div className="text-sm text-gray-300 mt-2">
                Your new total: <span className="font-bold text-white">{userScore}</span> points
              </div>
            </div>
          </div>

          <div className="text-sm text-gray-400">
            🌟 Keep sharing to help others discover the fascinating world of behavioral economics!
          </div>
        </FeedbackModal>
  )
}
